import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetProcesadosTurno = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/reportes/count-by-turn/${params}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getProcesadosTurno: mutation.mutate,
  };
}

export const GetProcesadosReporteTurno = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/reportes/report-by-turn/${params?.almacen}?turno=${params?.turno}&fecha_inicio=${params?.inicio}&fecha_fin=${params?.fin}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getProcesadosReporteTurno: mutation.mutate,
  };
}

export const DownloadExcelTurnos = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/reportes/report-by-turn/${params.almacen}/download-excel?turno=${params?.turno}&fecha_inicio=${params?.inicio}&fecha_fin=${params?.final}&usuarios=${params?.usuarios}`, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
      responseType: 'blob', // Indicamos que esperamos un archivo binario (blob)
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    getDownloadExcelTurnos: mutation.mutate,
  };
}